/** Decorative only — the initials of a name a card already displays in full. */
const initialsOf = (name: string | null | undefined) =>
  name
    ?.split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("") || null

export { initialsOf }
